import "animate.css/animate.min.css";
import "@/assets/sass/theme.scss";

export default {
  install(Vue) {
    // Vue.use(GlobalComponents);
    // Vue.use(GlobalDirectives);
    // Vue.use(SideBar);
    // Vue.use(Notify);
    // Vue.use(BootstrapVue);
  }
}